/** An edge between two castles -- the representation of a tunnel in the overworld */
import kontra from 'kontra';

import pathImage from '../../assets/path.png';

import { bearing, distance } from '../utilities';
import Particles from '../particles';

const { Sprite, imageAssets, emit } = kontra;

const DOTSIZE = 24;

export default class Edge extends Sprite.class {
  constructor (properties) {
    const { c1, c2, ...otherProperties } = properties;
    super(otherProperties);

    this.c1 = c1;
    this.c2 = c2;
    this.image = imageAssets[pathImage];

    this.health = 66 + (33 * Math.random());
    this.maxHealth = 100;

    this.active = false;
    this.offset = 0;
  }

  damage () {
    const damage = 10 + Math.floor(25 * Math.random());
    this.health -= damage;
    const position = this.getMidpoint();
    setTimeout(() => {
      Particles.addParticle({
        ttl: 1500,
        position: {
          x: position.x * 0.5,
          y: position.y * 0.5
        },
        velocity: { y: -20 },
        style: { opacity: [1, 0], scale: [2, 1, 1, 1, 1] },
        contents: `-${damage.toFixed(0)}%`
      });
    }, Math.random() * 200);
  }

  getHealthString () {
    return `${this.health.toFixed(0)}%`;
  }

  update () {
    this.offset += 0.25;
    this.offset %= DOTSIZE;
  }

  getMidpoint () {
    return {
      x: (this.c1.x + this.c2.x) / 2,
      y: (this.c1.y + this.c2.y) / 2
    };
  }

  render () {
    const start = {
      x: this.c1.x + 32,
      y: this.c1.y + 48
    };
    const end = {
      x: this.c2.x + 32,
      y: this.c2.y + 48
    };

    const heading = bearing(start, end);
    const castleDistance = distance(start, end);

    this.context.save();
    this.context.translate(start.x, start.y);
    this.context.rotate(heading);

    const multiple = castleDistance / 8;
    this.context.fillStyle = `rgba(0, 153, 0, ${1 - (this.health / this.maxHealth)})`;

    for (let x = 0; x < multiple; x++) {
      this.context.drawImage(this.image, 8 * x, -8);
      this.context.fillRect(8 * x, -8, 8, 16);
    }

    if (this.active) {
      const dotMultiple = castleDistance / DOTSIZE;
      const healthFrac = this.health / this.maxHealth;
      this.context.fillStyle = `rgba(200, ${200 * healthFrac}, ${200 * healthFrac}, ${0.2 + 0.8 * healthFrac})`;
      for (let x = 0; x < dotMultiple; x++) {
        this.context.fillRect(DOTSIZE * x + this.offset, -8, 16, 16);
      }
    }

    this.context.restore();
  }
}
